import React from 'react';
import OSPanel from '@/components/ui/OSPanel';
import MagneticButton from '@/components/ui/MagneticButton';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen w-full flex items-center justify-center bg-[#050A10] p-6">
          <OSPanel className="max-w-md w-full p-10 text-center bg-white/5 border-white/10" hover={false}>
            <div className="mb-6 flex justify-center">
              <div className="w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center border border-red-500/20">
                <div className="w-8 h-8 rounded-full bg-red-500 animate-pulse" />
              </div>
            </div>
            <h1 className="font-heading text-2xl text-white mb-2">System Interruption</h1>
            <p className="text-slate-400 text-sm mb-8">
              A rendering anomaly occurred. The neural mesh has been paused to protect data integrity.
            </p>
            <div onClick={() => window.location.reload()}>
              <MagneticButton className="w-full bg-white text-[#050A10]">
                Reboot System
              </MagneticButton>
            </div>
          </OSPanel>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
